<template>
  <div
    class="text-center"
    cols="2"
  >
    <i
      aria-hidden="true"
      :class="classHandler"
    />
  </div>
</template>

<script>

export default {
  name: 'AlarmExhibitionColumn',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    classHandler() {
      return this.value ? 'fas fa-eye'
        : 'fas fa-eye-slash alarm-exhibition-column__hidden';
    },
  },

};
</script>

<style lang="sass" scoped>
  .alarm-exhibition-column
    &__hidden
      opacity: 0.6
</style>
